module.exports = {
    props: ['user', 'teams'],
};



// WEBPACK FOOTER //
// ./spark/resources/assets/js/settings/teams.js